/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "seo.title", // Translation key
  description: "seo.description", // Translation key
  og: {
    title: "seo.ogTitle", // Translation key
    description: "seo.ogDescription", // Translation key
    type: "website",
    url: "https://mohamedsamir1495.me",
    image: "seo.ogImage", // Translation key
  },
};

//Home Page
const greeting = {
  title: "greeting.title", // Translation key
  logo_name: "greeting.logo_name", // Translation key
  nickname: "",
  subTitle: "greeting.subTitle", // Translation key (array)
  resumeLink:
    "https://drive.google.com/file/d/1x5MZpeSn2U3YcZih4coUDLTwrPQsyTef/view?usp=sharing",
  portfolio_repository: "https://github.com/mohamedsamir1495",
  githubProfile: "https://github.com/mohamedsamir1495",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/mohamedsamir1495",
    fontAwesomeIcon: "fa-github",
    backgroundColor: "#181717",
  },
  {
    name: "LinkedIn",
    link: "https://linkedin.com/in/mohamedsamir1495",
    fontAwesomeIcon: "fa-linkedin-in",
    backgroundColor: "#0077B5",
  },
  {
    name: "YouTube",
    link: "https://www.youtube.com/@mohamedsamir1495",
    fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
    backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  },
  {
    name: "Gmail",
    link: "mailto:mohamedsamir1495@gmail.com",
    fontAwesomeIcon: "fa-google",
    backgroundColor: "#D14836",
  },
  //  {
  //    name: "X-Twitter",
  //    link: "https://twitter.com/ashutosh_1919",
  //    fontAwesomeIcon: "fa-x-twitter", // Reference https://fontawesome.com/icons/x-twitter?f=brands&s=solid
  //    backgroundColor: "#000000", // Reference https://simpleicons.org/?q=x
  //  },
  //  {
  //    name: "Facebook",
  //    link: "https://www.facebook.com/laymanbrother.19/",
  //    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
  //    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  //  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/mohamedsamir1495/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "portfolio.skills.title", // Translation key
      fileName: "FullStackImg",
      skills: "portfolio.skills.descriptions", // Translation key (array)
      softwareSkills: [
        {
          skillName: "Java",
          fontAwesomeClassname: "logos:java",
          style: { color: "#007396" },
        },
        {
          skillName: "Spring",
          fontAwesomeClassname: "simple-icons:spring",
          style: { color: "#6DB33F" },
        },
        {
          skillName: "Spring Boot",
          fontAwesomeClassname: "simple-icons:springboot",
          style: { color: "#6DB33F" },
        },
        {
          skillName: "React",
          fontAwesomeClassname: "logos:react",
          style: { color: "#61DAFB" },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "logos:nodejs",
          style: { color: "#339933" },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "logos:javascript",
          style: { color: "#F7DF1E" },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "logos:typescript-icon",
          style: { color: "#3178C6" },
        },
        {
          skillName: "JUnit",
          fontAwesomeClassname: "simple-icons:junit5",
          style: { color: "#25A162" },
        },
        {
          skillName: "Gherkin",
          fontAwesomeClassname: "simple-icons:cucumber",
          style: { color: "#23D96C" },
        },
        {
          skillName: "Jest",
          fontAwesomeClassname: "logos:jest",
          style: { color: "#C21325" },
        },
        {
          skillName: "Maven",
          fontAwesomeClassname: "simple-icons:apachemaven",
          style: { color: "#C71A36" },
        },
        {
          skillName: "Gradle",
          fontAwesomeClassname: "simple-icons:gradle",
          style: { color: "#02303A" },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "logos:npm-icon",
          style: { color: "#CB3837" },
        },
        {
          skillName: "Cargo",
          fontAwesomeClassname: "simple-icons:rust",
          style: { color: "#DEA584" },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "logos:mysql",
          style: { color: "#4479A1" },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "logos:postgresql",
          style: { color: "#336791" },
        },
        {
          skillName: "Oracle Database",
          fontAwesomeClassname: "simple-icons:oracle",
          style: { color: "#F80000" },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "logos:mongodb",
          style: { color: "#47A248" },
        },
        {
          skillName: "Couchbase",
          fontAwesomeClassname: "simple-icons:couchbase",
          style: { color: "#EA2328" },
        },
        {
          skillName: "Redis",
          fontAwesomeClassname: "logos:redis",
          style: { color: "#DC382D" },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: { color: "#326CE5" },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: { color: "#FF9900" },
        },
        {
          skillName: "GitLab CI",
          fontAwesomeClassname: "simple-icons:gitlab",
          style: { color: "#FC6D26" },
        },
        {
          skillName: "Jenkins",
          fontAwesomeClassname: "logos:jenkins",
          style: { color: "#D24939" },
        },
        {
          skillName: "RabbitMQ",
          fontAwesomeClassname: "simple-icons:rabbitmq",
          style: { color: "#FF6600" },
        },
        {
          skillName: "Apache Kafka",
          fontAwesomeClassname: "logos:kafka",
          style: { color: "#231F20" },
        },
        {
          skillName: "Apache NiFi",
          fontAwesomeClassname: "simple-icons:apache",
          style: { color: "#0066CC" },
        },
        {
          skillName: "OpenTelemetry",
          fontAwesomeClassname: "simple-icons:opentelemetry",
          style: { color: "#000000" },
        },
        {
          skillName: "Prometheus",
          fontAwesomeClassname: "simple-icons:prometheus",
          style: { color: "#E6522C" },
        },
        {
          skillName: "Zipkin",
          fontAwesomeClassname: "simple-icons:apache",
          style: { color: "#0066CC" },
        },
        {
          skillName: "Kibana",
          fontAwesomeClassname: "logos:kibana",
          style: { color: "#005571" },
        },
        {
          skillName: "Grafana",
          fontAwesomeClassname: "logos:grafana",
          style: { color: "#F46800" },
        },
        {
          skillName: "Scrum",
          fontAwesomeClassname: "simple-icons:scrumalliance",
          style: { color: "#6DB33F" },
        },
        {
          skillName: "Kanban",
          fontAwesomeClassname: "simple-icons:trello",
          style: { color: "#0079BF" },
        },
        {
          skillName: "TDD",
          fontAwesomeClassname: "simple-icons:testcafe",
          style: { color: "#F5DE19" },
        },
        {
          skillName: "BDD",
          fontAwesomeClassname: "simple-icons:cucumber",
          style: { color: "#23D96C" },
        },
        {
          skillName: "Problem Solving",
          fontAwesomeClassname: "simple-icons:lightbulb",
          style: { color: "#FFD700" },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/mohamedsamir1495/",
    },
  ],
};

const degrees = {
  degrees: [
    {
      // Master's degree - text content now in translation files
      logo_path: "cu_logo.png",
      website_link: "https://ieeexplore.ieee.org/document/10066275/",
    },
    {
      // Bachelor's degree - text content now in translation files
      logo_path: "cu_logo.png",
      website_link: "https://cu.edu.eg/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "AWS Certified Cloud Practitioner",
      subtitle: "Amazon Web Services Training and Certification",
      logo_path: "aws_cloud_practitioner.png",
      certificate_link:
        "https://www.credly.com/badges/5cb27628-13e0-4855-b5f5-a492b695b1a0",
      alt_name: "AWS",
      color_code: "#ffffffff",
    },
    {
      title: "Professional Scrum Developer",
      subtitle: "Scrum.org",
      logo_path: "scrum_icon.png",
      certificate_link:
        "https://www.credly.com/badges/20c297e2-1e1e-44b0-b4b8-2c76abdfceb0",
      alt_name: "Scrum.org",
      color_code: "#ffffffff",
    },
    {
      title: "Front-End Web Development with React",
      subtitle: "Coursera",
      logo_path: "coursera_logo.svg",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/6AYCTAPLCNMC",
      alt_name: "Coursera",
      color_code: "#0056D2",
    },
    {
      title: "Oracle Certified Professional, Java SE 8 Programmer",
      subtitle: "Oracle",
      logo_path: "oracle_logo.png",
      certificate_link:
        "https://www.credly.com/badges/298bd8bb-d271-4f73-92b5-8ef42fa65b6e",
      alt_name: "Oracle",
      color_code: "#E0E0E0",
    },
    {
      title: "Oracle Certified Associate, Java SE 8 Programmer",
      subtitle: "Oracle",
      logo_path: "oracle_logo.png",
      certificate_link:
        "https://www.credly.com/badges/88edd191-a5b4-4340-a808-0a32d9781459",
      alt_name: "Oracle",
      color_code: "#E0E0E0",
    },
    {
      title: "Agile Foundation Certificate",
      subtitle: "Software Engineering Competence Center (ITIDA-SECC)",
      logo_path: "secc_logo.jpg",
      certificate_link:
        "https://drive.google.com/file/d/1BXLB8XBY-j9tmd_n_GnwzCTfT1IXwHUV/view",
      alt_name: "ITIDA-SECC",
      color_code: "#F5F5F5",
    },
    {
      title: "Android Developer Track",
      subtitle: "Udacity",
      logo_path: "udacity_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1j1hLX-qJ3Tkot73C-e-mV0QKlgUnimQm/view",
      alt_name: "Udacity",
      color_code: "#F7F7F7",
    },
    {
      title: "Game Design and Development Specialization",
      subtitle: "Coursera",
      logo_path: "coursera_logo.svg",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/NWBTPK5M364Q",
      alt_name: "Coursera",
      color_code: "#0056D2",
    },
    {
      title: "Application Security Analyst - Mastery Award for Students",
      subtitle: "IBM",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.youracclaim.com/badges/f0f45bd2-8f4f-432a-9bdc-ab3218bbe0b1",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "ACM ECPC Certificate Of Achievement",
      subtitle: "ACM",
      logo_path: "acm_logo.png",
      certificate_link:
        "https://drive.google.com/open?id=1pFd8MW9AF1vfNbXhUVmHnn4deiBRO3tQ",
      alt_name: "ACM",
      color_code: "#ffbb00ff",
    },
  ],
};

// Experience Page
const experience = {
  title: "experience.title", // Translation key
  subtitle: "experience.subtitle", // Translation key
  description: "portfolio.experience.description", // Translation key
  careerStartYear: 2017,
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          // Unifonic - text content now in translation files
          company_url: "https://www.unifonic.com",
          logo_path: "unifonic_logo.jpg",
          color: "#0099CC",
        },
        {
          // Amazon - text content now in translation files
          company_url: "https://www.amazon.com",
          logo_path: "amazon_logo.png",
          color: "#FFFFF",
        },
        {
          title: "Staff Software Engineer",
          company: "Cegedim",
          company_url: "https://www.cegedim.com",
          logo_path: "cegedim_logo.png",
          duration: "Mar 2021 – May 2024",
          location: "Cairo, Egypt",
          description: [
            "Designed and led migration workflow from relational DB (XML) to Couchbase using JavaFX, Apache NiFi, Spring Boot",
            "Built Node.js mock server for Romanian government APIs, reducing feature turnaround time by 50%",
            "Upgraded MLM app from Spring 2 to 4, integrated Redis for session sharing between microservices",
            "Integrated Maiia patient data with MLM and Maiia Agenda using Async APIs and Kafka",
            "Implemented crash logging in frontend app, cutting debugging interactions by 50%",
            "Developed new features and tests across multiple medical software systems",
          ],
          color: "#FFFFF",
        },
        {
          title: "Software Developer",
          company: "Orange Innovation Labs",
          company_url: "https://www.orange.com/en/innovation",
          logo_path: "orange_logo.png",
          duration: "Jan 2019 – Feb 2021",
          location: "Cairo, Egypt",
          description: [
            "Migrated Bot Trigger Tool backend from Node.js to Spring Boot monolithic plugin architecture",
            "Developed schedulers with Spring Boot, Apache Camel, RabbitMQ, MariaDB, Mongo, Redis",
            "Implemented TDD with JUnit4 & Jest, added BDD with Cucumber",
            "Enhanced React frontend with campaign statistics view using React Charts",
          ],
          color: "#FF7900",
        },
        {
          title: "Software Developer",
          company: "Ready Apps LLC",
          company_url: "https://www.linkedin.com/company/ready-apps-llc/",
          logo_path: "ready_apps_logo.png",
          duration: "Nov 2017 – Dec 2018",
          location: "Cairo, Egypt",
          description: [
            "Revamped frontend design for Nebka Client and Nebka Vendor apps (Android & iOS)",
            "Developed Nebka Analytics app for pharmacy vendors to monitor financial performance, increasing product usage by 70%",
          ],
          color: "#FFFFFF",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Top Talent – One Million Arab Coders Initiative",
          company: "Dubai Future Foundation",
          company_url: "https://www.onemillionarabcoders.ae/",
          logo_path: "one_million_arab_coder_logo.jpg",
          duration: "Dec 2017 - Jan 2018",
          location: "Dubai, UAE",
          description: [
            "Enrolled in the One Million Arab Coders initiative, a program launched by His Highness Sheikh Mohammed bin Rashid Al Maktoum to train one million young Arabs in programming.",
            "Completed the web development track among 1.1 million applicants across the Arab world, and graduated as one of the top-tier coders out of over 22,000 graduates that year.",
            "Selected as one of the distinguished participants invited to Dubai for the initiative’s annual ceremony, held at VOX Cinema, Mall of the Emirates.",
            'Represented Egypt as a web developer and was interviewed by Gulf News about my experience in the program (<a href="https://gulfnews.com/going-out/society/22000-graduate-from-one-million-arab-coders-initiative-1.2298070" target="_blank" rel="noopener noreferrer">Read the interview</a>).',
            "Networked with global companies and technology leaders, including representatives from Microsoft, Google, and Facebook, during the initiative’s open-day career event.",
          ],
          color: "#000000",
        },
        {
          title: "Web Development Trainee",
          company: "ZAD Solutions",
          company_url: "https://www.zadsolutions.com/",
          logo_path: "zad_solutions_logo.png",
          duration: "Jun 2017 - Aug 2017",
          location: "Cairo, Egypt",
          description: [
            "Completed an intensive 3-month training program focused on web development fundamentals.",
            "Gained hands-on experience with HTML, CSS, Bootstrap, PHP, and jQuery.",
            "Built small-scale projects from scratch, applying core web technologies to strengthen practical skills.",
          ],
          color: "#FFFFFF",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Microsoft Student Tech Club - Cairo",
          company: "Microsoft",
          company_url: "https://www.microsoft.com/",
          logo_path: "microsoft_logo.png",
          duration: "Apr 2016 - Apr 2017",
          location: "Cairo, Egypt",
          description: [
            "Conducted workshops for students on the Microsoft WPF platform, demonstrating how to use it for building mobile applications.",
            "Introduced fundamental Xamarin concepts to enhance cross-platform development skills.",
            "Mentored students in developing real projects and guided them in presenting their work at Microsoft’s Smart Village branch in Cairo.",
          ],
          color: "#D83B01",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description: "Some of my published Articles, Blogs and Research.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "proactive-auto-scaling-framework",
      name: "Proactive Auto-Scaling Framework (PAF)",
      createdAt: "2023-03-10T00:00:00Z",
      description:
        "Published in IEEE Access (Vol. 11, 2023). Presents PAF, an ensemble of statistical, ML, and neural models for forecasting cloud resources (CPU/RAM) and recommending scaling for production systems. Evaluated on 3 production apps (Cegedim Cloud Hosting).",
      url: "https://doi.org/10.1109/ACCESS.2023.3256302",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "mohamedsamir1495_contact.jpg",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with ML, AI, React, Android, Cloud and Opensource Development.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I like to document some of my experiences in professional career journey as well as some technical knowledge sharing.",
    link: "https://medium.com/@mohamedsamir1495",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle:
      "Hassan Mousa Street, Al Abageyah, El Mokattam, Cairo Governorate, Egypt",
    locality: "Cairo",
    country: "Egypt",
    region: "Cairo Governorate",
    postalCode: "11585",
    streetAddress: "Hassan Mousa Street, Al Abageyah, El Mokattam",
    avatar_image_path: "address_image.svg",
    location_map_link:
      "https://www.google.com/maps/place/29%C2%B059'36.7%22N+31%C2%B018'14.0%22E",
  },
  phoneSection: {
    title: "Phone",
    subtitle: "+20 114 885 0051",
    link: "tel:+201148850051",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
